import styles from './ProjectAccessRequestsDialog.module.css';

import React, { useMemo, useState } from 'react';

import Dialog from 'components/ui/Dialog';
import { BngIconButton } from 'components/bng/ui/BngIconButton';
import Api from 'components/Api';
import BngTable from 'components/bng/ui/BngTable';
import useTranslation from 'components/hooks/useTranslation';
import { DefaultDialogActions } from 'components/ui/FormUtils';
import UiMsg from 'components/ui/UiMsg';
import BimEventBus from 'BimEventBus';
import { RELOAD_EVENT } from 'components/ui/recent-activities/RecentActivities';

export default function ProjectAccessRequestsDialog({ closeModal = _.noop, requests = [] }) {
  const { t } = useTranslation();

  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);

  const cols = useMemo(() => {
    return [
      {
        key: 'user',
        label: t('user'),
        render: (row) => (
          <div>
            <span>{row.requestedUser.email}</span>
          </div>
        ),
      },
      {
        key: 'project',
        label: t('project'),
        render: (row) => (
          <div>
            <span>{row.project.name}</span>
          </div>
        ),
      },
      {
        key: 'actions',
        label: t('actions'),
        render: (row) => {
          const match = answers[row.id];
          const acceptButtonSelected = match === true;
          const rejectButtonSelected = match === false;

          return (
            <div className={styles.actionButtonWrapper}>
              <BngIconButton
                className={`${styles.actionButtons} ${styles.rejectButton} ${
                  rejectButtonSelected && styles.rejectButtonSelected
                }`}
                icon="close"
                onClick={() => {
                  const copy = {
                    ...answers,
                    [row.id]: false,
                  };

                  setAnswers(copy);
                }}
              />
              <BngIconButton
                className={`${styles.actionButtons} ${styles.activateButton} ${
                  acceptButtonSelected && styles.activateButtonSelected
                }`}
                icon="done"
                onClick={() => {
                  const copy = {
                    ...answers,
                    [row.id]: true,
                  };

                  setAnswers(copy);
                }}
              />
            </div>
          );
        },
      },
    ];
  }, [answers]);

  return (
    <Dialog
      className={`ProjectAccessRequestsDialog ${styles.ProjectAccessRequestsDialog}`}
      title={t('project.access.requests.list.title')}
      onClose={closeModal}
      loading={loading}
    >
      <Dialog.Body>
        <div className={styles.headerWrapper}>
          <p>{t('project.access.requests.list.description')}</p>
        </div>
        <div className={styles.RequestsTableWrapper}>
          <BngTable className={styles.RequestsTable} cols={cols} rows={requests} stickyHeader={true} />
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <DefaultDialogActions
          className={styles.dialogFooter}
          closeModal={closeModal}
          cancelLabel={t('not.now')}
          okLabel={t('save')}
          onClickSaveButton={async () => {
            setLoading(true);
            try {
              const requestBody = Object.entries(answers).map(([requestId, accept]) => ({ requestId, accept }));
              await Api.ProjectAccessRequest.answerRequests(requestBody);
              BimEventBus.emit(RELOAD_EVENT);
              closeModal();
            } catch (e) {
              console.error('Error on answerRequests()', e);
              UiMsg.ajaxError(null, e);
              setLoading(false);
            }
          }}
        />
      </Dialog.Footer>
    </Dialog>
  );
}
